import React from 'react';
import $ from 'jquery';

import NrgComponent from './../NrgComponent.jsx';
import Navigation from './Navigation/Navigation.jsx';
import Extension from './Extension/Extension.jsx';
import VideoBox from './VideoBox/VideoBox.jsx';
import MovingLines from './MovingLines/MovingLines.jsx';
import { ReactComponent as NrgStagwellIcon } from '../../icons/svg/logo-b.svg';
import { ReactComponent as DownArrowIcon } from '../../icons/svg/down-arrow.svg';

export default class GenericHeader extends NrgComponent {

  constructor(props) {
    super(props);

    this.stickyHeight = 100;
    this.topOffset = 65;
    this.stickyEnabled = false;
    this.animationTime = 150;
    this.$ele = null;
    this.offScreen = false;
  }
  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(undefined);
    }
  }
  render() {
    var extension = (this.props.page === 'homepage') ? <Extension page={this.props.page} /> : null;

    return (
      <div className="GenericHeader row">
        <MovingLines type="above" />
        <MovingLines type="below" />
        <div className="col-xs-16 navigation-container">
          <div ref="stickyMenu" className="stickyable-nav">
            <div className="nrg-logo">
              <a href="./">
                <NrgStagwellIcon viewBox="0 0 307.1 113.6"></NrgStagwellIcon>
              </a>
            </div>
            <Navigation page={this.props.page} />
          </div>
        </div>
        <div ref="stickyMenuActivationPoint" className="col-xs-16 video-container">
          <VideoBox page={this.props.page} />
        </div>
        <div className="col-xs-16 down-arrow-container">
          <div className="down-arrow" onClick={() => { this._moveDown() }}>
            <DownArrowIcon viewBox="0 0 40 40"></DownArrowIcon>
          </div>
        </div>
        {extension}
      </div>
    );
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }

    // Activate the sticky nav when the user scrolls beyond the fold
    // const theFold = new Waypoint(
    //   {
    //     element: this.refs.stickyMenuActivationPoint,
    //     handler: (direction) => {
    //       // Activate sticky nav
    //       if (this.stickyEnabled === false && direction === 'down') {
    //         this.stickyEnabled = true;
    //         this._activateSticky();
    //         this.hideStickyScroll();
    //       }
    //     }
    //   }
    // );

    // // De-activate the sticky nav when the user scrolls back to the top
    // const theTop = new Waypoint(
    //   {
    //     'element': $('body'),
    //     'offset': -this.topOffset,
    //     'handler': (direction) => {
    //       if (this.stickyEnabled === true && direction === 'up') {
    //         this.stickyEnabled = false;
    //         this._deactivateSticky();
    //       }
    //     }
    //   }
    // );

    // Detect upward or downward scrolls for showing/hiding the sticky nav below the fold
    // NOTE - potential performance issues if not carefully considered
    var lastScrollTop;
    $(window).scroll((event) => {
      var top = $(window).scrollTop();
      if (top > lastScrollTop) {
        this.userScrolledUp();
      } else {
        this.userScrolledDown();
      }
      lastScrollTop = top;
    });

    this.$ele = $(this.refs.stickyMenu);
  }

  hideStickyScroll() {
    if (this.offScreen === true) {
      return;
    }

    this.$ele.stop();

    this.$ele.css({
      'margin-top': -this.stickyHeight
    });

    this.offScreen = true;
  }

  showStickyScroll() {
    if (this.offScreen === false) {
      return;
    }

    this.$ele.removeClass('hidden').animate({
      'marginTop': 0
    }, this.animationTime);

    this.offScreen = false;
  }

  userScrolledUp() {
    if (this.stickyEnabled === false) {
      return;
    }

    this.hideStickyScroll();
  }

  userScrolledDown() {
    if (this.stickyEnabled === false) {
      return;
    }

    this.showStickyScroll();
  }

  _openNews() {
    this.props.newsActions.openPanel();
  }

  _moveDown() {
    const height = $(window).height();

    // WebKit needs body, others html
    // Technically runs twice on webkit, but works ok
    $('body,html').animate({
      'scrollTop': height
    }, 550);
  }

  _activateSticky() {
    this._disableNavigationTransitions(this.$ele);
    this.$ele.addClass('sticky');
  }

  _deactivateSticky() {
    this._enableNavigationTransitions(this.$ele);
    this.$ele.removeClass('sticky');
  }

  _disableNavigationTransitions($ele) {
    $ele.find('.Navigation a').each((index, item) => {
      $(item).attr('data-skip-transition', true);
    });
  }

  _enableNavigationTransitions($ele) {
    $ele.find('.Navigation a').each((index, item) => {
      $(item).removeAttr('data-skip-transition');
    });
  }

};
